import 'reflect-metadata';
import CssContact from './css-contact.entity';
import { Column, Entity, JoinColumn, OneToMany, ManyToOne, PrimaryGeneratedColumn } from 'typeorm';
import { BaseEntite, CalendrierScolaire, Client, Contact, EntiteStatique, FiltrableEntiteStatique } from './index';
import { Lieu } from './lieu.entity';

@EntiteStatique()
@Entity('region')
export class Region implements BaseEntite {
    static key = 'region';
    @PrimaryGeneratedColumn()
    id: number;
    @Column()
    name: string;
}

@FiltrableEntiteStatique<CentreServiceScolaire>()
@EntiteStatique()
@Entity('centre_service_scolaire')
export class CentreServiceScolaire implements BaseEntite {
    static key = 'centres-service-scolaire';

    static non_privileged_properties: (keyof CentreServiceScolaire)[] = ['id', 'name', 'abbr'];
    static regular_privileged_properties: (keyof CentreServiceScolaire)[] = ['id', 'name', 'abbr'];
    static admin_privileged_properties: (keyof CentreServiceScolaire)[] = [];

    @PrimaryGeneratedColumn()
    id: number;
    @Column()
    name: string;
    @Column({ nullable: true })
    abbr: string;
    @Column({ nullable: true })
    link: string;
    @Column({ nullable: true })
    email: string;
    @Column({ nullable: true })
    notes: string;
    @Column({ nullable: true })
    num_fournisseur: string;
    @Column({ nullable: true })
    fk_id_lieu: number;
    @ManyToOne(() => Lieu)
    @JoinColumn({ name: 'fk_id_lieu', referencedColumnName: 'id' })
    lieux: Lieu;
    @Column({ nullable: true })
    fk_id_region: number;
    @ManyToOne(() => Region)
    @JoinColumn({ name: 'fk_id_region', referencedColumnName: 'id' })
    region?: Region;
    @Column({ nullable: true })
    fk_id_contact_par_defaut: number;

    @ManyToOne(() => Contact)
    @JoinColumn({ name: 'fk_id_contact_par_defaut', referencedColumnName: 'id' })
    contact_par_defaut: Contact;

    @OneToMany(() => CssContact, (cssContact: CssContact) => cssContact.css)
    contacts: CssContact[];

    @OneToMany(() => Client, (client: Client) => client.centre_service_scolaire, { cascade: true })
    clients: Client[];

    @OneToMany(() => CalendrierScolaire, (calendriers: CalendrierScolaire) => calendriers.centre_service_scolaire, {
        cascade: true,
    })
    calendriers: CalendrierScolaire[];
}
